import api from '../api';

const ADMIN_INVENTORY_BASE = '/products/admin';

const cleanParams = (params = {}) => {
  const result = {};

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      value !== 'undefined' &&
      value !== 'null'
    ) {
      result[key] = value;
    }
  });

  return result;
};

const adminInventoryService = {
  searchSuppliers: async (query) => {
    const { data } = await api.get(`${ADMIN_INVENTORY_BASE}/suppliers/search/`, {
      params: cleanParams({ query }),
    });
    return data;
  },

  getSupplierWarehouses: async (supplierId) => {
    if (!supplierId) return [];
    const { data } = await api.get(
      `${ADMIN_INVENTORY_BASE}/suppliers/${supplierId}/warehouses/`
    );
    return data;
  },

  getInventoryTable: async (params = {}) => {
    const { data } = await api.get(
      `${ADMIN_INVENTORY_BASE}/inventory/warehouse-table/`,
      {
        params: cleanParams(params),
      }
    );
    return data;
  },

  exportInventory: async (params = {}) => {
    const { data } = await api.get(`${ADMIN_INVENTORY_BASE}/inventory/export/`, {
      params: cleanParams(params),
    });
    return data;
  },
};

export default adminInventoryService;
